<div>
    <aeg-test-payment-data />
    <vl-radio-tile name="payment-method" value="card" id="payment-method-card"
                   key="payment-method-card" v-model="inputValue"
                   title="Online betaling">
        <div class="card-logos">
            <img :src="mastercard" alt="Mastercard"/>
            <img :src="visa" alt="Visa"/>
            <img :src="bancontact" alt="Bancontact"/>
        </div>
    </vl-radio-tile>
    <vl-radio-tile class="prepaid" name="payment-method" value="prepaid" v-model="inputValue"
                   id="payment-method-prepaid"
                   key="payment-method-prepaid" :title="prepaidTitle" :mod-disabled="prepaidDisabled" v-if="allowPrepaid">
        <template v-if="userHadPrepaidBefore">
            <div class="prepaid-saldo">
                Huidig saldo:
                <span :class="{'prepaid-saldo__value': true, 'prepaid-saldo__value--sufficient': hasSufficientPrepaidBalance}">
                    {{ formatCurrency(prepaidBalance) }}
                </span>
                <span class="prepaid-saldo__deficiency" v-if="!hasSufficientPrepaidBalance">
                    {{ formatCurrency(prepaidBalanceDeficiency) }} te weinig - <vl-link @click="addPrepaid">aanvullen</vl-link>
                </span>
            </div>
        </template>
        <template v-else>
            <vl-link @click="addPrepaid">Laad prepaid saldo op</vl-link>
        </template>
    </vl-radio-tile>
</div>